var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'antd/dist/antd.css';
import './i18n';
import './antdesign.css';
import './index.css';
import store from './redux/configureStore';
import App from './App';
import { initSentry } from './config/sentry.config';
// Initialize Sentry for error tracking (non-blocking, async)
initSentry();
ReactDOM.render(_jsx(React.StrictMode, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(App, {}, void 0) }), void 0) }, void 0), document.getElementById('root'));
